import { render } from "./DriverDetails.vue?vue&type=template&id=4418adde"
import script from "./DriverDetails.vue?vue&type=script&lang=js"
export * from "./DriverDetails.vue?vue&type=script&lang=js"

import "./DriverDetails.vue?vue&type=style&index=0&id=4418adde&lang=css"
script.render = render

export default script